//import $ from 'jquery';

import { View } from 'backbone';
import template  from 'dashboard/forms/modal/create-form-instance-modal.ejs';
import RestService      from 'RestService.js';
import NotificationService from 'NotificationService.js';
import eventBus  from 'EventBus.js';

class CreateFormInstanceModal extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#createFormInstanceModal";

        this.model.set('result', 'NO');
        return this;
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set('result', propVal);
    }

    bindEvents() {
        $('input[type=radio][name=redirect]').change((e)=>{
            this.updateRadioAttributes(e);
        });
    }

    unbindEvents() {
        $('input[type=radio][name=redirect]').unbind();
    }

    closeModal() {
        $(this.El).remove();
    }

    render() {
        return new Promise((resolve, reject) => {                        
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);
            //this.$el.append(template(this.model.toJSON()));
            let self = this;

            this.dialog = $('#createFormInstanceModal').dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 250,
                width: 450,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class':'btn-select-field',
                        click: () => {
                            self.unbindEvents();
                            self.dialog.dialog( "close" );
                            resolve( self.model.get('result') );
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            self.dialog.dialog("close");
                            self.closeModal();
                            reject();
                        }
                    }
                ],
                close: () => {
                    self.dialog.dialog("destroy");
                    self.closeModal();
                },
                open: () =>{
                    self.bindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

            this.delegateEvents();            
            return this;
        });
    }

}

export default CreateFormInstanceModal;
